// extracted by mini-css-extract-plugin
export default {"root":"PageKidC_root__2MqNg","inner":"PageKidC_inner__oXFwg","content":"PageKidC_content__nTLuo","back":"PageKidC_back__hlUTV"};